import { Outlet } from 'react-router-dom';

import { Header } from 'components/Header';
import { DashboardWrapper } from 'pages/Dashboard/styles';

const Dashboard = () => {
  return (
    <DashboardWrapper>
      <Header />
      <Outlet />
    </DashboardWrapper>
  );
};

export default Dashboard;
